import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAppSelector } from '@/app/store/hooks';
import {
  selectIsAuthenticated,
  selectIsInitialized,
} from '@/features/auth/store/auth-slice';
import { Loader } from '@/shared/components/loader';
import { ROUTES } from '@/app/router/route-constants';

/**
 * Protects authenticated routes.
 * Redirects unauthenticated users to /login with return URL preserved.
 */
export function AuthGuard() {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const isInitialized = useAppSelector(selectIsInitialized);
  const location = useLocation();

  if (!isInitialized) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader size="lg" label="Initializing session" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  return <Outlet />;
}
